export default () => {
  const checkoutSteps = document.querySelector('.js-checkout-steps')
  if (!checkoutSteps) return

  const nextButtons = [...document.querySelectorAll('.js-checkout-button-next')]
  ;[...nextButtons].forEach(button =>
    button.addEventListener('click', function() {
      // Value fields
      const billingFirstname = (document.querySelector(
        `.c-woocommerce-billing-fields__billing-firstname`
      ).innerHTML = document.querySelector(`#billing_first_name`).value)
      const billingLastname = (document.querySelector(
        `.c-woocommerce-billing-fields__billing-lastname`
      ).innerHTML = document.querySelector(`#billing_last_name`).value)
      const billingAddress = (document.querySelector(
        `.c-woocommerce-billing-fields__billing-address`
      ).innerHTML = document.querySelector(`#billing_address_1`).value)
      const billingPostcode = (document.querySelector(
        `.c-woocommerce-billing-fields__billing-zipcode`
      ).innerHTML = document.querySelector(`#billing_postcode`).value)
      const billingCity = (document.querySelector(
        `.c-woocommerce-billing-fields__billing-city`
      ).innerHTML = document.querySelector(`#billing_city`).value)
      const billingCountry = (document.querySelector(
        `.c-woocommerce-billing-fields__billing-country`
      ).innerHTML = document.querySelector(`#billing_country`).value)

      const shippingFirstname = (document.querySelector(
        `.c-woocommerce-billing-fields__shipping-firstname`
      ).innerHTML = document.querySelector(`#shipping_first_name`).value
        ? document.querySelector(`#shipping_first_name`).value
        : document.querySelector(`#billing_first_name`).value)
      const shippingLastname = (document.querySelector(
        `.c-woocommerce-billing-fields__shipping-lastname`
      ).innerHTML = document.querySelector(`#shipping_last_name`).value
        ? document.querySelector(`#shipping_last_name`).value
        : document.querySelector(`#billing_last_name`).value)
      const shippingAddress = (document.querySelector(
        `.c-woocommerce-billing-fields__shipping-address`
      ).innerHTML = document.querySelector(`#shipping_address_1`).value
        ? document.querySelector(`#shipping_address_1`).value
        : document.querySelector(`#billing_address_1`).value)
      const shippingPostcode = (document.querySelector(
        `.c-woocommerce-billing-fields__shipping-zipcode`
      ).innerHTML = document.querySelector(`#shipping_postcode`).value
        ? document.querySelector(`#shipping_postcode`).value
        : document.querySelector(`#billing_postcode`).value)
      const shippingCity = (document.querySelector(
        `.c-woocommerce-billing-fields__shipping-city`
      ).innerHTML = document.querySelector(`#shipping_city`).value
        ? document.querySelector(`#shipping_city`).value
        : document.querySelector(`#billing_city`).value)
      const shippingCountry = (document.querySelector(
        `.c-woocommerce-billing-fields__shipping-country`
      ).innerHTML = document.querySelector(`#shipping_country`).value
        ? document.querySelector(`#shipping_country`).value
        : document.querySelector(`#billing_country`).value)

      const shippingFirstnameValue = document.querySelector(
        `#shipping_first_name`
      ).value
      const shippingLastnameValue = document.querySelector(
        `#shipping_last_name`
      ).value
      const shippingAddressValue = document.querySelector(`#shipping_address_1`)
        .value
      const shippingcontainer = document.querySelector(
        `.c-woocommerce-billing-fields__shipping`
      )

      if (
        shippingFirstnameValue &&
        shippingLastnameValue &&
        shippingAddressValue
      ) {
        shippingcontainer.classList.remove('hidden')
      }
    })
  )
}



// WEBPACK FOOTER //
// ./src/js/modules/CheckoutFieldValues.js